module.exports = __webpack_public_path__ + "static/media/video_consent_audio_gujarati.9f7719c8.mp3";